/**
 * cs-*-controller :售后服务
 */
import bom from './bom';

export default {
  bom,
};
